module.exports = __webpack_public_path__ + "img/img-icon.a2726921.png";